import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { Goal } from 'shared/types/goal';

export const useFilteredLocalizedLifeAreas = (goals: Goal[]) => {
  const user = useUser();
  const lifeAreas = useSortedLocalizedLifeAreas();

  return useMemo(() => {
    return lifeAreas.filter(
      ({ id, archivedAt }) =>
        !archivedAt &&
        (user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas ||
          goals.some(
            ({ lifeAreaId, parentIds }) =>
              !parentIds?.length && lifeAreaId === id,
          )),
    );
  }, [
    goals,
    lifeAreas,
    user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas,
  ]);
};
